import moment = require("moment");
import {UIState} from "data/UIState";

interface IDateFormat {
  formatString:string;
}

const DateFormats = {
  MONTH_AND_YEAR: { formatString: 'MMMM yyyy' },
  STANDARD: { formatString: 'M/D/yyyy' },
  DATE_AND_TIME: { formatString: 'M/D/yyyy, h:mm a'},
};

export const Helpers = {
  standardDate: (srcDate:Date|null|undefined) => { return Helpers.formattedDate(DateFormats.STANDARD, srcDate);},
  monthAndYear: (srcDate:Date|null|undefined) => { return Helpers.formattedDate(DateFormats.MONTH_AND_YEAR, srcDate);},
  dateAndTime: (srcDate:Date|null|undefined) => { return Helpers.formattedDate(DateFormats.DATE_AND_TIME, srcDate);},

  formattedDate: (format:IDateFormat, srcDate:Date|null|undefined) => {
    if(srcDate) {
      try {
       return moment(srcDate).tz(UIState.settings.DEPLOYMENT_TIMEZONE).format(format.formatString);
      } catch(err) {
        console.log(err);
      }
    }
    return "";
  }

}